module.exports = __webpack_public_path__ + "img/agriculture/square_icon3.130d2112.png";